/**
 * 图片上传
 * 2019-05-28 chenxiaojian
 */
import React from 'react';
import { Icon } from 'antd';

import '../../style/common/uploadImage.css';
import Loading from './Loading';
import http from '../../axios/http';
import server from '../../axios/server';
import ImageView from './ImageView';

import {getBase64} from '../../util/util.js';
import messager from './messager';

class ImageUpload extends React.Component {

    state = {
        // image: null,
        previewVisible: false,
        previewImage: null,
        loadingVisible: false
    }

    clickUpload = (e) => {
        let fileInput = this.refs.fileInput;
        fileInput.click();
    }

    uploadImage = (e) => {
        let files = e.target.files;
        if (files.length === 1) {
            this.handleImageUpload(files[0]);
        }
        else {
            this.handleMultipleUpload(files);
        }
    }
    handleImageUpload = async file => {
        this.setState({loadingVisible: true})
        getBase64(file).then(base64 => {
            http.post({
                url: "/image/save/temp",
                data: {image: base64},
                success: (url) => {
                    this.setState({loadingVisible: false})
                    if (this.props.onChange) {
                        this.props.onChange({url});
                    }
                    this.refs.fileInput.value = '';
                },
                error: () => {
                    this.setState({loadingVisible: false})
                    messager.notify("上传图片失败！")
                }
            });
        });
    }

    
    showOnloading = () => {
        this.setState({loadingVisible: true})
    }

    hidOnloading = () => {
        this.setState({loadingVisible: false})
    }

    handleMultipleUpload = files => {
        this.setState({loadingVisible: true})
        let base64Images = [];
        let length = files.length;
        for (let i = 0; i < length; i++) {
            let file = files[i];
            getBase64(file).then(base64 => {
                base64Images.push(base64);
                if (this.props.onMultipleChange && base64Images.length === length) {
                    http.post({
                        url: "/image/save/temps",
                        data: {images: JSON.stringify(base64Images)},
                        success: (urls) => {
                            this.setState({loadingVisible: false})
                            this.props.onMultipleChange({urls});
                            // this.refs.fileInput.value = '';
                        },
                        error: () => {
                            this.setState({loadingVisible: false})
                            messager.notify("上传图片失败！")
                        }
                    });
                    
                }
                if (i === 0) {
                    this.refs.fileInput.value = '';
                }
            });
        }
    }

    handleImagePreview = () => {
        const { url } = this.props;
        if (url == null || url === "") {
            return ;
        }
        //因为现在展示的是缩略图，所以要从服务器上再下载水印图展示
        http.post({
            url: '/common/getWatermarkImage',
            data: { url: url },
            success: (res) => {
                if (res != null && res !== "") {
                    let f = "data:image/jpeg;base64," + res;
                    this.setState({
                        previewImage: f,
                        previewVisible: true,
                    });
                }
            }
        });

    }
    handleCancel = () => {
        this.setState({ previewVisible: false })
    };

    handleImageRemove = () => {
        this.refs.fileInput.value = '';
        if (this.props.onRemove) {
            this.props.onRemove();
        }
    }

    render() {
        const { text, url, type, onlyView } = this.props;
    
        let flag = (url == null || url === "");
        let href = flag ? "" : (server.httpServerUrl + "/common/image?imagePath=" + encodeURI(url));
        let align = type === 'button' ? "left" : "center";
        return (
            <div> 
                <div className={type === 'button' ? '' : "def-picture-card"} >
                    <div hidden={!flag} style={{ verticalAlign: "middle", textAlign: align, display: flag ? '' : "none" }}>
                        {onlyView === true ? null :
                            <div>
                                <Icon type="camera" style={{ fontSize: '28px', margin: '5px', color: '#19be6b', cursor: 'pointer' }} onClick={this.props.openScanner} />
                                <Icon type="picture" style={{ fontSize: '28px', margin: '5px', color: '#40a9ff', cursor: 'pointer' }} onClick={this.clickUpload.bind(this)} />
                                <input type="file" multiple={this.props.multiple} accept="image/jpg,image/jpeg,image/png" onChange={this.uploadImage.bind(this)} style={{ display: "none" }} ref="fileInput" />
                            </div>
                        }
                        <span>{text}</span>
                    </div>
                    <div className="def-upload-item-info" style={{ display: flag ? "none" : '' }}>
                        <img alt="" src={href}></img>
                    </div>
                    <span className="def-upload-item-actions" style={{ display: flag ? "none" : '' }}>
                        <Icon type="eye" onClick={this.handleImagePreview} />
                        {onlyView === true ? null :
                            <Icon type="delete" onClick={this.handleImageRemove} />
                        }
                    </span>
                </div>
                <ImageView src={this.state.previewImage} visible={this.state.previewVisible} handleCancel={this.handleCancel}/>
                <Loading
                    visible={this.state.loadingVisible}
                    message="正在上传"
                />
            </div>
        );
    }
}

export default ImageUpload;